import React,{useState} from 'react';
import { Typography, Box, Card, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
// import Link from '@mui/material/Link';
import { Link } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import CategoryTable from '../../components/Datatable/CategoryTable'
import ListIcon from '@mui/icons-material/List';
import AddIcon from '@mui/icons-material/Add';
import FormEditProfile from '../../components/Forms/FormEditProfile';


function handleClick(event) {
  const value = event.target.value;
  console.log(value);
}

const EditUser = () => {
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));
  const breadcrumbs = [
    <Link underline="hover" key="1" style={{ textDecoration: 'none' ,color:'#3c7f06'}} to={'/dashboard'} onClick={handleClick} >
      Dashboard
    </Link>,
    <Link underline="hover" key="1" style={{ textDecoration: 'none' ,color:'#3c7f06'}} to={'/users-customer'} onClick={handleClick} >
    Profile
  </Link>,
    <Typography key="3" sx={{ color: '#99abb4' }}>
      Edit User
    </Typography>,
  ];
  return (
    <Box className="categories-con-cls">
      <DrawerHeader />
      <Card sx={{ display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "start", sm: "center" },
        gap:1,
        flexWrap:'wrap',
        justifyContent: "space-between", p:  { xs: "20px", sm: "20px 40px" }, boxShadow: '1px 0 5px rgba(0, 0, 0, 0.1)' }}>
        <Typography variant="body1" sx={{ mb: 0, color: '#000', fontWeight: 600, fontSize: "22px" }}>
        Profile
        </Typography>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Card>

      {/*  */}
            <Box sx={{ p: 2 }}>
                <FormEditProfile />
            </Box>        
    </Box>
  );
};

export default EditUser;
